const classes = {
  mainBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  navLink: {
    marginLeft: 3,
    marginRight: 3
  },
  outlinedBox: {
    width: '2.25rem',
    height: '2.25rem',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    borderRadius: '4px',
    transition: 'border-color 0.15s ease, background 0.15s ease',
    '&:hover': {
      borderColor: '#fff',
      background: 'rgba(255, 255, 255, 0.08)'
    }
  },
  // The default margins would push the icon off-centre inside the square.
  outlinedNavLink: {
    display: 'flex',
    alignItems: 'center'
  },
  iconClass: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    }
  }
}

export default classes
